import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "authConfig";

let instance: PublicClientApplication | null = null;

// Lazily construct a single shared MSAL instance so the non-React service layer
// can trigger re-auth using the same instance passed to MsalProvider, without
// constructing it at module import time.
export function getMsalInstance(): PublicClientApplication {
  if (!instance) {
    instance = new PublicClientApplication(msalConfig);
  }
  return instance;
}
